
          if (!('Proxy' in window)) {
            window.Proxy = function ProxyPonyfill(obj) {
              return obj;
            };
          }
          window.global = window;
        